import React, { Component } from 'react';
import { ButtonReg } from 'atoms/Buttons';
import Breadcrumb from 'molecules/Breadcrumb';
import RemoteDataTable from 'organisms/RemoteDataTable';
import {
  COAL_STOCK_FINALIZE,
  COAl_STOCK_INVENTORIES,
  DOWNLOAD_TEMPLATE,
  PREVIEW_UPLOAD,
  SYNC_MASTER_DATA,
  UPLOAD_EXCEL,
} from 'fixtures/api';
import {
  stockOpnameAcknowledge,
  stockOpnameCreate,
  stockOpnameDelete,
  stockOpnameRead,
  stockOpnameUpdate,
} from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { getAllAreasData } from 'Redux/actions/AreaActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  ContainerHeaderBtn,
  FilterAction,
  FilterCol,
  FilterRow,
  HideButtonFinalize,
  LevelRowContainer,
  PageWrapper,
  RoundedWrapper,
  StyledPicker,
  TableWrapper,
} from './styles';
import lo from 'lodash';

import { Label } from 'components/atoms/Texts/TxtLabel';
import FormSelect from 'components/atoms/Inputs/FormSelect';
import { Icon } from 'components/atoms/Icon/index';
import IconPng from 'components/atoms/IconPng/index';
import { actionFormatter3 } from 'components/molecules/TableFormatters/actionFormatterNav';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { getAllList, postNewData } from 'services/cmsService';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ModalPage from 'components/templates/ModalPage/index';
import ImportExcelUploadModal from 'components/organisms/StockOpnameImport/ImportExcelUploadModal';
import DownloadTemplateModal from 'components/organisms/DownloadTemplateModal/index';
import ImportExcelPreviewModal from 'components/organisms/StockOpnameImport/ImportExcelPreviewModal';
import DropdownButton from 'components/molecules/Dropdown/index';

const ic_eye = require('App/assets/images/ic_eye.png')
const defaultFilter = {
  companyCode: '-',
  areaCode: '-',
  period: new Date(new Date().setMonth(new Date().getMonth()-1)),
}

export class StockOpnameList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navList: [
        'Stock Opname',
        'Stock Opname List'
      ],
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
      allowView: true,
      allowAcknowledge: false,
      search: '',
      filter: lo.cloneDeep(defaultFilter),
      page: 1,
      limit: 7,
      sortBy: '',
      sortDir: '',
      data: [],
      totalData: 0,
      grandTotal: 0,
      canFinalize: false,
      isChangeFilter: false,
      isShowImportExcelUploadModal: false,
      isShowDownloadTemplateModal: false,
      isShowImportExcelPreviewModal: false,
      importExcelUploadAttachments: null,
      companyDownloadList: '-',
      resultPreviewUpload: null,
      isValidResultPreviewUpload: true,
      tempImportExcelUploadAttachments: null
    }
  }

  componentDidMount() {
    const { lookups, settingsTable } = this.props
    this.checkPermission()
    const savedFilter = settingsTable.filter && settingsTable.filter[this.state.navList[0]]
      ? JSON.parse(settingsTable.filter[this.state.navList[0]])
      : null

    this.setState(
      {
        filter: savedFilter
          ? {
              ...savedFilter,
              period: new Date(savedFilter.period)
            }
          : {
              ...this.state.filter,
              ...(lookups.companies.length && {
                companyCode: lookups.companies[0].code,
              })
            }
      },
      () => {
        this.fetchData()
      }
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const { userLogin } = this.props
    const { page, limit, sortBy, sortDir, filter } = this.state
    
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }

    if (prevState.filter.companyCode !==  filter.companyCode) {
      this.props.getAllAreasData(filter.companyCode === '-' ? '' : filter.companyCode)
    }

    if (
      prevState.page !== page ||
      prevState.limit !== limit ||
      prevState.sortBy !== sortBy ||
      prevState.sortDir !== sortDir
    ) {
      const { setLocalSettingsTableData, settingsTable } = this.props
      const settings = lo.cloneDeep(settingsTable)
      settings.sizePerPage[this.state.navList[0]] = limit
      setLocalSettingsTableData(settings)

      this.fetchData()
    }
  }

  buildParams = () => {
    const { settingsTable } = this.props

    const tableFilter = {
      ...this.state.filter,
      page: this.state.page,
      limit: settingsTable.sizePerPage[this.state.navList[0]] || this.state.limit,
      sortBy: this.state.sortBy ? this.stete.sortBy.replace(/\.(\w)/g, (_, letter) => letter.toUpperCase()) : '',
      sortDir: this.state.sortDir,
      search: this.state.search,
      period: moment(this.state.filter.period).format('YYYY-MM-DD')
    }
    const filter = lo.omitBy({ ...tableFilter }, (val) => !val || val === '-')
    const params = new URLSearchParams(filter).toString()
    return params
  }

  fetchData = async () => {
    this.props.toggleIsLoading(true)
    const params = this.buildParams()
    const data = await getAllList(`${COAl_STOCK_INVENTORIES}?${params ? `${params}` : ''}`)
    this.setState({ 
      data: data.coal_stock_inventories,
      totalData: data.total_data,
      grandTotal: data.grandTotal,
      canFinalize: data.canFinalize
    }, () => {
      this.props.toggleIsLoading(false)
    })
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, stockOpnameCreate),
        allowDelete: permissionCheck(permissions, stockOpnameDelete),
        allowUpdate: permissionCheck(permissions, stockOpnameUpdate),
        allowView: permissionCheck(permissions, stockOpnameRead),
        allowAcknowledge: permissionCheck(permissions, stockOpnameAcknowledge),
      })
    }
  }

  onEdit(row) {
    const { history: { push } } = this.props
    push(`/dash/stock-opname/edit/${row.id}`)
  }

  onViewUpload(row) {
    const { history: { push } } = this.props
    push(`/dash/stock-opname/view-upload?companyCode=${row.companyCode}&period=${row.period}`)
  }

  onTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    this.setState({
      page,
      limit: sizePerPage,
      sortBy: sortField,
      sortDir: sortOrder
    })
  }

  onChangeFilter(val, field) {
    this.setState({ isChangeFilter : true })
    let f = { ...this.state.filter }
    f[field] = val
    this.setState({ filter: f })
  }

  onFilterSubmit() {
    this.setState({ page: 1, isChangeFilter: false }, () => {
      this.fetchData()
    })

    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.filter[this.state.navList[0]] = JSON.stringify(this.state.filter)
    setLocalSettingsTableData(settings)
  }

  onResetFilter() {
    const { lookups } = this.props
    const newDefaultFilter = {
      ...lo.cloneDeep(defaultFilter),
      ...(lookups.companies.length && { companyCode: lookups.companies[0].code })
    }
    this.setState({ 
      filter: newDefaultFilter
    }, () => {
      this.fetchData()
    })

    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.filter[this.state.navList[0]] = JSON.stringify(newDefaultFilter)
    setLocalSettingsTableData(settings)
  }

  onSearch = (search) => {
    this.setState({ search }, () => {
      this.fetchData()
    })
  }

  onFinalize = () => {}

  addNewStockOpname() {
    const { history: { push } } = this.props
    push('/dash/stock-opname/add')
  }

  switchImportExcelUploadModal() {
    const { isShowImportExcelUploadModal } = this.state
    this.setState({ 
      isShowImportExcelUploadModal: !isShowImportExcelUploadModal,
      importExcelUploadAttachments: null
    })
  }

  handleCancelPreview() {
    const confirmCancel = window.confirm('Are you sure you want to cancel the data import?')
    if (!confirmCancel) return

    this.switchImportExcelPreviewModal()
  }

  switchDownloadTemplateModal() {
    const { isShowDownloadTemplateModal } = this.state
    this.setState({ 
      isShowDownloadTemplateModal: !isShowDownloadTemplateModal,
      companyToDownload: this.props.allowedCompanies[0].code
    })
  }

  switchImportExcelPreviewModal() {
    const { isShowImportExcelPreviewModal } = this.state
    this.setState({ isShowImportExcelPreviewModal: !isShowImportExcelPreviewModal }) 
  }

  checkValidation(data) {
    let isValid = true;

    if (data.companyCode.error !== null || data.period.error !== null || data.surveyDate.error !== null) {
      isValid = false;
    }

    data.coalStockInventories.forEach((inventory) => {
      if (inventory.areaCode.error !== null) {
          isValid = false;
      }

      inventory.coalStockInventoryDetails.forEach((detail) => {
        if (
          (typeof detail.dirLocationCode === 'object' && detail.dirLocationCode.error !== null) ||
          (typeof detail.productName === 'object' && detail.productName.error !== null) ||
          (typeof detail.volume === 'object' && detail.volume.error !== null) ||
          (typeof detail.factorScale === 'object' && detail.factorScale.error !== null) ||
          (typeof detail.startTime === 'object' && detail.startTime.error !== null) ||
          (typeof detail.endTime === 'object' && detail.endTime.error !== null)
        ) {
          isValid = false;
        }        
      });
    });

    return isValid;
  }

  async handleUploadFile() {
    this.props.toggleIsLoading(true)
    const body = {
      filename: this.state.importExcelUploadAttachments.filename,
      base64: this.state.importExcelUploadAttachments.file
    }

    const res = await postNewData(`${PREVIEW_UPLOAD}`, body)

    this.props.toggleIsLoading(false)
    if (res.status < 400) {
      this.setState({ 
        resultPreviewUpload: res.data,
        isValidResultPreviewUpload: this.checkValidation(res.data),
        tempImportExcelUploadAttachments: this.state.importExcelUploadAttachments.file
      })
      this.switchImportExcelUploadModal()
      this.switchImportExcelPreviewModal()

      return
    }

    const message = res.message
    alert(message)
    throw res
  }

  async handleSubmitFile() {
    const confirmSubmit = window.confirm('Are you sure you want to save the opname data ?')
    if (!confirmSubmit) return

    this.props.toggleIsLoading(true)
    const body = {
      ...this.state.resultPreviewUpload,
      file: {
        ...this.state.resultPreviewUpload.file,
        base64: this.state.tempImportExcelUploadAttachments
      }
    };

    const res = await postNewData(`${UPLOAD_EXCEL}`, body)

    this.props.toggleIsLoading(false)
    if (res.status < 400) {
      alert('Success!')
      window.location.reload()
      return
    }

    const message = res.message || 'Failed Submit'
    alert(message)
    throw res
  }

  renderFilterRow() {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
      arrowSize: '16px',
      arrowPos: 'calc(100% - 12px)'
    }

    const { filter } = this.state
    const { lookups, areas } = this.props

    const CustomInput = ({ value, onClick }) => (
      <StyledPicker
        onClick={onClick}
        value={value}
        {...inputConfig}
      />
    );

    return (
      <FilterRow>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Company Name
          </Label>
          <FormSelect
            placeholder={`Select company`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'companyCode')}
            options={lookups.companies ? lookups.companies : []}
            value={filter.companyCode}
            valField={'code'}
            dispField={'name'}
            arrowSize={'5%'}
            mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Area
          </Label>
          <FormSelect
            placeholder={`Select area`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'areaCode')}
            options={areas ? areas : []}
            value={filter.areaCode}
            valField={'code'}
            dispField={'code'}
            arrowSize={'5%'}
            mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Report Period
          </Label>
          <DatePicker
            dateFormat="MMM - yyyy"
            selected={filter.period}
            onChange={date => this.onChangeFilter(date, 'period')}
            showMonthYearPicker
            customInput={<CustomInput />}
          />
        </FilterCol>
        <FilterAction>
          <ButtonReg
            btnTxt={
              <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
            }
            rad={'6px'}
            disabled={false}
            onClick={this.onFilterSubmit.bind(this)}
            width={'34px'}
            height={'34px'}
            margin={'0 9px 0 0'}
          />
          <ButtonReg
            btnTxt="Reset"
            rad={'6px'}
            disabled={false}
            onClick={this.onResetFilter.bind(this)}
            height={'34px'}
            width={'50px'}
            margin={'0'}
          />
        </FilterAction>
      </FilterRow>
    )
  }

  sortCaretIcon = (order) => {
    const { theme } = this.props

    if (!order) return <Icon icon="sort" ml={'4px'} width={'16px'} color={theme.mocaPurple} />
    if (order === 'asc') return <Icon icon="sort-up" ml={'4px'} width={'16px'} color={theme.mocaPurple} />
    if (order === 'desc') return <Icon icon="sort-down" ml={'4px'} width={'16px'} color={theme.mocaPurple} />
    return null
  }

  formattedNumber = (num, decimals) => {
    return new Intl.NumberFormat('en-US', {maximumFractionDigits: decimals}).format(num)
  }

  finalizeStockOpname = async () => {
    const confirmFinalize = window.confirm('Are you sure you want to finalize?')
    if (!confirmFinalize) return

    try {
      this.props.toggleIsLoading(true)
      const tableFilter = {
        ...this.state.filter,
        search: this.state.search,
        period: moment(this.state.filter.period).format('YYYY-MM-DD')
      }
      const body = lo.omitBy({ ...tableFilter }, (val) => !val || val === '-')
      
      const res = await postNewData(`${COAL_STOCK_FINALIZE}`, body)

      if (res.status < 400) {
        alert('Success!')
        window.location.reload()
        return
      }

      const message = res.message || 'Failed to finalize'
      alert(message)
      throw res
    } catch {
      return
    } finally {
      this.props.toggleIsLoading(false)
    }
  }

  synchronizeStockOpname = async () => {
    const confirmSynchronize = window.confirm('Are you sure to continue syncronize master area, location and product?')
    if (!confirmSynchronize) return

    try {
      this.props.toggleIsLoading(true)
      
      const res = await postNewData(`${SYNC_MASTER_DATA}`)

      if (res.status < 400) {
        alert('Success!')
        window.location.reload()
        return
      }

      const message = res.message || 'Failed to synchronize'
      alert(message)
      throw res
    } finally {
      this.props.toggleIsLoading(false)
    }
  }

  handleDownloadTemplate = () => {
    if (this.props.allowedCompanies && this.props.allowedCompanies.length > 1) {
      this.switchDownloadTemplateModal()
      return
    }

    this.setState({ 
      companyToDownload: this.props.allowedCompanies[0].code
    }, () => {
      this.onDownloadTemplate()
    })
  }

  onChangeUploadFile(data) {
    this.setState({ importExcelUploadAttachments: data })
  }

  onChangeCompany(data) {
    this.setState({ companyToDownload: data })
  }

  onDownloadTemplate = async () => {
    window.open(
      `${DOWNLOAD_TEMPLATE}?${this.state.companyToDownload ? `companyCode=${this.state.companyToDownload}` : ""}`,
      '_blank',
    )
  }

  render() {
    const { allowCreate, navList, data, totalData, limit, page, grandTotal, canFinalize, isChangeFilter, isShowImportExcelUploadModal, isShowDownloadTemplateModal, isShowImportExcelPreviewModal } = this.state
    const { settingsTable, viewState: { isMobileView }, theme } = this.props

    const sizePerPage = settingsTable.sizePerPage[navList[0]] || limit

    const dropdownItems = [
      allowCreate && { label: 'Add Coal Stock', onClick: () => this.addNewStockOpname(), tooltip: null },
      allowCreate && { label: 'Import Excel', onClick: () => this.switchImportExcelUploadModal(), tooltip: null },
      { label: 'Synchronize', onClick: () => this.synchronizeStockOpname(), tooltip: 'Syncronize from TS & Mercy' },
      { label: 'Download Template', onClick: () => this.handleDownloadTemplate(), tooltip: null },
    ].filter(Boolean);

    const config = [
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerStyle: { width: 100 },
        formatter: actionFormatter3,
        formatExtraData: {
          color: this.props.theme.mocaPurple,
          allowEdit: () => this.state.allowUpdate,
          edit: (row) => this.onEdit.bind(this, row),
          allowView: () => this.state.allowView,
          view: (row) => this.onViewUpload.bind(this, row)
        },
        isDummyField: true,
        footer: () => <></>
      },
      {
        dataField: 'companyCode',
        headerStyle: { minWidth: isMobileView ? 100 : 120 },
        text: 'Company',
        sort: true,
        sortCaret: (order) => this.sortCaretIcon(order),
        footer: () => <div style={{ color: theme.mocaGreen, fontSize: 'bold'}}>GRAND TOTAL</div>
      },
      {
        dataField: 'area.name',
        text: 'Area',
        headerStyle: { minWidth: isMobileView ? 120 : 150 },
        sort: true,
        sortCaret: (order) => this.sortCaretIcon(order),
        footer: () => <></>
      },
      {
        dataField: 'totalTonnage',
        text: 'Tonnage',
        headerStyle: { minWidth: 120 },
        formatter: (cell, row) => {
          return <div style={{ textAlign: 'right'}}>{row.totalTonnage ? this.formattedNumber(row.totalTonnage, 3) : '-'}</div>
        },
        sort: true,
        sortCaret: (order) => this.sortCaretIcon(order),
        footer: () => (
          <div style={{ textAlign: 'right', color: theme.mocaGreen, fontSize: 'bold' }}>
            {this.formattedNumber(grandTotal, 3)}
          </div>
        )
      },
      {
        dataField: 'period',
        text: 'Stock Period',
        headerStyle: { minWidth: 150 },
        formatter: (cell, row) => {
          return <div style={{ textAlign: 'center'}}>{row.period ? `(1-${moment(row.period).date()}) ${moment(row.period).format('MMM-YYYY')}` : '-'}</div>
        },
        sort: true,
        sortCaret: (order) => this.sortCaretIcon(order),
        footer: () => <></>
      },
      {
        dataField: 'surveyDate',
        text: 'Survey Date',
        headerStyle: { minWidth: 120 },
        formatter: (cell, row) => {
          return <div style={{ textAlign: 'center'}}>{row.surveyDate ? moment(row.surveyDate).format('DD-MMM-YYYY') : '-'}</div>
        },
        sort: true,
        sortCaret: (order) => this.sortCaretIcon(order),
        footer: () => <></>
      },
      {
        dataField: 'status',
        headerStyle: { minWidth: 120 },
        text: 'Status',
        style: (cell, row) => {
          if (row && row.status === 'DRAFT') {
            return {
              color: theme.mocaOrange,
              fontWeight: 'bold'
            }
          }
          if (row && row.status === 'FINALIZED') {
            return {
              color: theme.mocaGreen,
              fontWeight: 'bold'
            }
          }
        },
        sort: true,
        sortCaret: (order) => this.sortCaretIcon(order),
        footer: () => <></>
      }
    ]

    return (
      <>
        <PageWrapper isMobile={isMobileView}>
          <Breadcrumb navList={navList} />
          <>
            <RoundedWrapper>
              {this.renderFilterRow()}
            </RoundedWrapper>
            <TableWrapper>
              <RemoteDataTable
                leftSlot={
                  <LevelRowContainer>
                    <DropdownButton items={dropdownItems} />
                    <HideButtonFinalize>
                      {
                        canFinalize && (
                          <ContainerHeaderBtn>
                            <ButtonReg
                              btnTxt={'Finalize'}
                              disabled={isChangeFilter}
                              onClick={() => this.finalizeStockOpname()}
                              width={'100px'}
                            />
                          </ContainerHeaderBtn>
                        )
                      }
                    </HideButtonFinalize>
                  </LevelRowContainer>
                }
                isMobile={isMobileView}
                dataList={data || []}
                columnConfig={config}
                page={page}
                sizePerPage={sizePerPage}
                totalSize={totalData}
                onTableChange={this.onTableChange}
                onSearch={this.onSearch}
              />
            </TableWrapper>
          </>
          <ModalPage
            isOpen={isShowImportExcelUploadModal}
            width={'600px'}
            maxHeight={'100%'}
            fnSwitch={this.switchImportExcelUploadModal.bind(this)}
            contentChild={
              <ImportExcelUploadModal
                fnSwitch={this.switchImportExcelUploadModal.bind(this)}
                importExcelUploadAttachments={this.state.importExcelUploadAttachments}
                onChange={this.onChangeUploadFile.bind(this)}
                handleUploadFile={this.handleUploadFile.bind(this)}
                {...this.props}
              />
            }
          />
        </PageWrapper>
        <ModalPage
          isOpen={isShowImportExcelPreviewModal}
          width={'90%'}
          maxHeight={'100%'}
          fnSwitch={this.switchImportExcelPreviewModal.bind(this)}
          contentChild={
            <ImportExcelPreviewModal
              fnSubmit={this.handleSubmitFile.bind(this)}
              result={this.state.resultPreviewUpload}
              isValidResult={this.state.isValidResultPreviewUpload}
              fnHandleCancel={this.handleCancelPreview.bind(this)}
              {...this.props}
            />
          }
        />
        <ModalPage
          isOpen={isShowDownloadTemplateModal}
          width={'600px'}
          height={'300px'}
          overflowY={'visible'}
          fnSwitch={this.switchDownloadTemplateModal.bind(this)}
          contentChild={
            <DownloadTemplateModal
              fnSwitch={this.switchDownloadTemplateModal.bind(this)}
              onChangeCompany={this.onChangeCompany.bind(this)}
              onDownload={this.onDownloadTemplate.bind(this)}
              companyToDownload={this.state.companyToDownload}
              {...this.props}
            />
          }
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  lookups.companies = lo.uniqBy(state.userLogin.userDetail.allowedCompanies.map((d) => ({ name: d.name, code: d.code })),
  'name',
  )
  return {
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable,
    lookups,
    areas: state.areaList,
    allowedCompanies: state.userLogin.userDetail.allowedCompanies
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      setLocalSettingsTableData,
      getAllAreasData
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(StockOpnameList)
  )
);